<template>
  <v-dialog v-model="showDialog" width="800px">
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <v-card class="search-modal">
      <h2 class="mb-3">Search & Add People</h2>
      <v-form @submit.prevent="search">
        <v-row>
          <v-spacer />
          <v-col>
            <v-text-field
              outlined
              v-model="membershipID"
              label="Member ID"
            />
          </v-col>
          <v-col>
            <v-btn v-on:click="search" color="primary">
              <v-icon> mdi-magnify </v-icon>
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <p v-if="!!searchResults && !searchResults.length && hasSearched">
        No members found
      </p>
      <v-data-table
        v-if="!!searchResults && searchResults.length"
        :headers="headers"
        :items="searchResults"
        hide-default-header
      >
        <template v-slot:item="row">
          <v-tooltip dark top>
            <template v-slot:activator="{ on, attrs }">
              <tr v-bind="attrs" v-on="on">                
                <td>
                  {{ row.item.firstName }} {{ row.item.lastName }}
                </td>
                <td>
                  <span v-if="row.item.memberId">&nbsp;
                      (<font-awesome-icon icon="id-card" :color="row.item.isActiveMember == false ? 'red' : 'green'" />
                        {{row.item.isActiveMember == false ? ' Expired' : ' Active'}} Member ID#: {{ row.item.memberId }})
                  </span>
                </td>
                <td>
                  <a v-on:click="add(row.item)">
                    <font-awesome-icon
                      icon="plus"
                      :color="row.item.canBeCoowner ? 'blue' : 'gray'"
                    />
                  </a>
                </td>
              </tr>
            </template>
            <span v-if="row.item.canBeCoowner == false">
              This person can't be a coowner.
            </span>
            <span v-else>
              <span v-if="row.item.isActiveMember == false">
                This person is inactive member, they'll be asked to renew their membership before they can approve registration.
              </span>              
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
      <p class="mb-6" v-if="selectedPeople.length">- or -</p>
      <v-btn
        color="primary"
        class="white--text"
        block
        :disabled="!selectedPeople.length"
        v-on:click="submit"
        >Continue</v-btn
      >
      <div v-if="selectedPeople.length">
        <h2 class="mt-8">Selected</h2>
        <v-data-table
          :headers="headers"
          :items="selectedPeople"
          hide-default-footer
          hide-default-header
        >
          <template v-slot:item="row">
            <tr v-bind="attrs" v-on="on">              
              <td>
                <span>
                  <b>
                    {{ row.item.firstName }} {{ row.item.lastName }}
                    <span v-if="row.item.memberId">&nbsp;
                      (<font-awesome-icon icon="id-card" :color="row.item.isActiveMember == false ? 'red' : 'green'" />
                        {{row.item.isActiveMember == false ? ' Expired' : ' Active'}} Member ID#: {{ row.item.memberId }})</span>
                  </b>
                </span> 
              </td>
              <td>
                <a v-on:click="remove(row.item)">
                  <font-awesome-icon icon="minus" />
                </a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import { CoownerValidationResult } from "@/types/portal/Registration";

export default Vue.extend({
  name: "EditableCoOwnersListDialog",
  data: function () {
    return {
      showDialog: this.$props.peopleSearchDialog,
      hasSearched: false,
      searchResults: [] as any[],
      selectedPeople: this.$props.selectedPeopleList
        ? [...this.$props.selectedPeopleList]
        : [],
      membershipID: "",
      nameSearchText: "",
      judgeId: "",
      headers: [
        { text: "Name", align: "left", value: "name" },
        { text: "Member ID", align: "left", value: "memberId" },
      ],
      on: "",
      attrs: "",
      isLoading: false,
    };
  },
  watch: {
    peopleSearchDialog: function (newVal: boolean) {
      if (!newVal) {
        this.membershipID = "";
        this.hasSearched = false;
        this.searchResults = [] as CoownerValidationResult[];
      }
      this.showDialog = newVal;
    },
    selectedPeopleList: function (newVal: any) {
      this.selectedPeople = newVal;
    },
  },
  methods: {
    search: function () {
      this.isLoading = true;
      this.hasSearched = false;
      this.searchCoownersFn(this.membershipID)
        .then((response: any) => {
          this.isLoading = false;
          this.hasSearched = true;
          this.searchResults = response;
        });
    },
    isActivemember(coowner: CoownerValidationResult) {
      return coowner.isActiveMember;
    },
    add(row: CoownerValidationResult) {
      if (this.selectedPeople.length >= 6) return;
      if (this.selectedPeople.some((el) => el.personId === row.personId)) return;
      if (!row.canBeCoowner) return;
      this.searchResults = [] as CoownerValidationResult[];
      this.hasSearched = false;
      this.membershipID = "";      
      this.$emit("personAdded", { personId: row.personId });
      this.selectedPeople.push(row);
    },
    remove(row: any) {
      this.selectedPeople.splice(this.selectedPeople.indexOf(row), 1);
      this.changeSelectedPeopleInfo(this.selectedPeople);
    },
    submit() {
      this.changeSelectedPeopleInfo(this.selectedPeople);
      this.showDialog = false;
    },
  },
  props: {
    changeSelectedPeopleInfo: Function,
    peopleSearchDialog: Boolean,
    toggleModal: Function,
    selectedPeopleList: Array,
    searchCoownersFn: Function,
  },
});
</script>